export default __webpack_public_path__ + "static/media/ranes11.7299f99a.jpg";